/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from "react";
//Google Tag Manager
import TagManager from "react-gtm-module";
// Import global business context
import { BusinessContextConsumer } from "../BusinessContext.js";
import { Modal, Button } from "react-bootstrap";

const AnalyticsProvider = ({children}) => {
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const { gtmTag, planType } = BusinessContext.businessID;
  useEffect(async () => {
    if (localStorage.getItem("marketingCookieConsent") === null && gtmTag !== "") {
      setConsentModalOpen(true);
    }

    const cookieConsent = JSON.parse(localStorage.getItem("marketingCookieConsent")) === "true";
    //Initialize the tracking if the right planType, and the GTM tag exists, and cookie consent is given.
    if (planType >= 2 && gtmTag !== "" && cookieConsent) {
      //Initialize Tag Manager
      const tagManagerArgs = {
        gtmId: gtmTag,
      };
      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  const closeConsentModal = () => {
    setConsentModalOpen(false);
    return localStorage.setItem("marketingCookieConsent", JSON.stringify("false"));
  };

  const consentToCookies = () => {
    setConsentModalOpen(false);
    localStorage.setItem("marketingCookieConsent", JSON.stringify("true"));
    //Initialize Tag Manager
    const tagManagerArgs = {
      gtmId: this.context.gtmTag,
    };
    return TagManager.initialize(tagManagerArgs);
  };

  return (
    <div id='analyticsProvider'>
      {children}

      {/*Cookie Consent Modal*/}
      <Modal
        show={consentModalOpen}
        size='lg'
        onHide={closeConsentModal}
        scrollable
        backdrop='static'
      >
        <Modal.Header>
          <Modal.Title>Cookies on our Application</Modal.Title>
        </Modal.Header>
        <Modal.Body scrollable>
          <p>
            We use two types of cookie on this application. We want you to know about them and tell
            us your preferences:
          </p>

          <p>
            <strong>Essential Cookies:</strong> these cookies are core to the functioning of our
            application and it will not work unless you allow them. Without accepting these cookies,
            services you have asked for cannot be provided. We use these cookies for securing your
            login, accessing your services and facilitating payments.
          </p>

          <p>
            <strong>Analytic and Marketing Cookies:</strong> We use these cookies to understand your
            behaviour on our application, personalize your experience and deliver tailored
            advertising to you, on and off our website, as well as other uses in our privacy and
            cookie policy.
          </p>
          <p>
            <strong>Please indicate your preferences before continuing.</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-primary' size='lg' onClick={closeConsentModal}>
            Essential Only
          </Button>
          <Button variant='primary' size='lg' onClick={consentToCookies}>
            Accept All
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

//Export
export default AnalyticsProvider;
